import React from 'react';
import { HipHopHub } from './components/HipHopHub';
export function App() {
  return <div className="w-full min-h-screen bg-[#0A0A0A]" data-id="element-0">
      <HipHopHub data-id="element-1" />
    </div>;
}